module.exports = __webpack_public_path__ + "media/media/advantages/international_team-7b643faecc9e1da0f3eff7913304bee0.jpg";